import { createAsyncThunk } from '@reduxjs/toolkit';
import { BasePropertyDTO, DispensingPropertiesDTO } from 'business/models/Models';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';

export const getGeneralDispensingPropertiesThunk = createAsyncThunk<
  DispensingPropertiesDTO,
  void
>('getGeneralDispensingPropertiesThunk', async (_, thunkApi) => {
  try {
    const resp = (
      await new GlobalPreferencesService().getGlobalDispensingProperties()
    ).toJSON();
    resp.generalProperties = generalPropertiesToJson(resp.generalProperties);
    return resp;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const saveGeneralDispensingPropertiesThunk = createAsyncThunk<
  boolean,
  DispensingPropertiesDTO
>(
  'saveGeneralDispensingPropertiesThunk',
  async (properties: DispensingPropertiesDTO, thunkApi) => {
    try {
      return await new GlobalPreferencesService().saveGlobalDispensingProperties(
        properties,
      );
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

const generalPropertiesToJson = (
  properties: { [key: string]: BasePropertyDTO[] } | undefined,
) => {
  const data = {};
  if (properties) {
    for (const key in properties) {
      if (properties.hasOwnProperty(key) && properties[key].length) {
        properties[key].forEach((property) => {
          const _property = {};
          for (const propKey in property) {
            _property[propKey === '_discriminator' ? 'discriminator' : propKey] =
              property[propKey];
          }
          if (!Array.isArray(data[key])) {
            data[key] = [];
          }

          data[key].push(_property);
        });
      } else {
        data[key] = [];
      }
    }
  }
  return data;
};
